<template>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="pageContainer">
      <div class="row">
        <div class="col-sm-9">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard">
                  <div class="row">
                    <div class="col-sm-4">
                     <h4 class="reference">{{ order.order_number }}</h4>
                    </div>
                    <div class="col-sm-8" v-if="order.status === 'draft'">
                      <div align="right">
                        <router-link class="btnGreenLineSmall" :to="{name: 'OrdersEdit', params: { id: $route.params.id }}">Edit Order</router-link> <a style="margin-left:10px;" class="btnRedLineSmall" @click.prevent="deleteOrder()">Delete</a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <hr />
                    </div>
                  </div>
                  <form @submit.prevent="updateOrder">
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="itemsGroup">
                          <div class="itemsList">
                            <dt class="item">Contact</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select>
                                  <option v-for="contact in contacts" :key="contact.id" :value="contact.id" :selected="contact.id === order.contact_id">{{ contact.first_name }} {{ contact.last_name }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          <div class="itemsList">
                            <dt class="item">Billing</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select>
                                  <option v-for="address in addresses" :key="address.id" :value="address.id" :selected="address.id === order.billing_address_id">({{ address.label }}) {{ address.address1 }}, {{ address.address2 }}, {{ address.city }}, {{ address.county }}, {{ address.postcode }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                          <div class="itemsList">
                            <dt class="item">Shipping</dt>
                            <dd class="item">
                              <div class="commerceSelect">
                                <select>
                                  <option v-for="address in addresses" :key="address.id" :value="address.id" :selected="address.id === order.shipping_address_id">({{ address.label }}) {{ address.address1 }}, {{ address.address2 }}, {{ address.city }}, {{ address.county }}, {{ address.postcode }}</option>
                                </select>
                              </div>
                            </dd>
                          </div>
                        </div>
                      </div>
                        <div class="col-sm-4">
                          <div class="itemsGroup">
                            <div class="itemsList">
                              <dt class="item">Issue Date</dt>
                              <dd class="item">
                                {{ order.issued_at | formatDate }}
                              </dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Delivery Date</dt>
                              <dd class="item">
                                {{ order.ship_at | formatDate }}
                              </dd>
                            </div>
                            <div class="itemsList">
                              <dt class="item">Reference</dt>
                              <dd class="item">{{ order.customer_reference }}</dd>
                            </div>
                          </div>
                        </div>
                      <div class="col-sm-4">
                        <div class="itemsGroup">
                          <div class="itemsList">
                            <dt class="item">Currency</dt>
                            <dd class="item">{{ order.currency }}</dd>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <hr />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <table class="orderItem">
                          <thead>
                            <tr>
                              <th>Item Name</th>
                              <th style="width: 9%;">Quantity</th>
                              <th style="width: 9%;">Available</th>
                              <th style="width: 16%;">Price (GBP)</th>
                              <th style="width: 80px;">Discount</th>
                              <th style="width: 80px;">VAT</th>
                              <th style="width: 12%;">Total (GBP)</th>
                              <th style="width: 30px;"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="orderitem in orderitems" :key="orderitem.id">
                              <td>
                                {{ orderitem.name }}
                                <span v-if="orderitem.name"><br /><span v-if="orderitem.label"><br />Note:<br /></span></span>
                                <span v-if="orderitem.label">{{ orderitem.label }}</span>
                              </td>
                              <td>{{ orderitem.quantity }}</td>
                              <td></td>
                              <td>&pound;{{ orderitem.unit_price.toFixed(2) }}</td>
                              <td>{{ orderitem.discount }}%</td>
                              <td>
                                {{ orderitem.taxrate }}%
                              </td>
                              <td>&pound;{{ orderitem.total_price }}</td>
                              <td></td>
                            </tr>
                          </tbody>
                          <tfoot>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <textarea v-model="order.notes" rows="5" placeholder="Order notes"></textarea>
                      </div>
                      <div class="col-sm-1"></div>
                      <div class="col-sm-5">
                        <div class="row">
                          <div class="col-sm-6">
                            Sub-Total
                          </div>
                          <div class="col-sm-6">
                            &pound;{{ order.order_subtotal }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            Delivery
                          </div>
                          <div class="col-sm-6">
                            &pound;{{ order.order_delivery }}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            VAT
                          </div>
                          <div class="col-sm-6">
                            &pound;{{ order.order_vat }}
                          </div>
                        </div>
                        <div class="row" style="margin-top:10px;">
                          <div class="col-sm-6">
                            <strong>Total</strong>
                          </div>
                          <div class="col-sm-6">
                            <strong>&pound;{{ order.order_total.toFixed(2) }}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <hr />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-1">
                        <label style="text-align: left;">Tags</label>
                      </div>
                      <div class="col-sm-3">
                        <input type="text" v-model="order.tags">
                      </div>
                      <div class="col-sm-8">
                        <div align="right">
                          <input type="submit" value="Save Order">
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Order</h6>
                    </div>
                  </div>
                  <div class="row" v-if="order.status === 'draft'">
                    <div class="col-sm-12">
                      <a class="btnOrderAction" @click.prevent="finaliseOrder()">Finalise <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                  <div class="row" v-else>
                    <div class="col-sm-6">
                      Status:
                    </div>
                    <div class="col-sm-6">
                      {{ order.status }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Invoices</h6>
                    </div>
                  </div>
                  <div class="row" v-if="order.status === 'active'">
                    <div class="col-sm-12">
                      <a class="btnOrderAction" @click.prevent="invoiceOrder()">Invoice order <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                  <div class="row" v-if="order.status === 'finalised' || order.status === 'fullfilled'">
                    <div class="col-sm-6">
                      Invoice Date:
                    </div>
                    <div class="col-sm-6">
                    </div>
                  </div>
                  <div class="row" v-if="order.status === 'finalised' || order.status === 'fullfilled'">
                    <div class="col-sm-6">
                      Invoice Number:
                    </div>
                    <div class="col-sm-6">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Payments</h6>
                    </div>
                  </div>
                  <div v-if="order.invoice_status === 'invoiced'">
                  <div class="row" v-if="order.payment_status === 'paid'">
                    <div class="col-sm-6">
                      Invoice Paid
                    </div>
                  </div>
                  <div class="row" v-else>
                    <div class="col-sm-12">
                      <a class="btnOrderAction" @click.prevent="payOrder()">Mark Paid <font-awesome-icon icon="angle-double-right" /></a>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>Shipments</h6>
                    </div>
                  </div>
                  <div v-if="order.invoice_status === 'invoiced'">
                    <div class="row" v-if="order.fulfillment_status === 'shipped'">
                      <div class="col-sm-6">
                        Order Sent:
                      </div>
                    </div>
                    <div class="row" v-else>
                      <div class="col-sm-12">
                        <a class="btnOrderAction" @click.prevent="fulfillOrder()">Fulfill Order <font-awesome-icon icon="angle-double-right" /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="pageCard greenTop">
                  <div class="row">
                    <div class="col-sm-12">
                      <h6>History</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  components: { },
  data () {
    return {
      order: [],
      orderitems: [],
      contacts: [],
      addresses: [],
      variants: []
    }
  },
  watch: {
    productInput (after, before) {
      if (after === null || before === null) {
        this.DoNothing()
      } else {
        this.searchProduct()
      }
    }
  },
  created () {
    axios
      .get(`/api/orders/${this.$route.params.id}`)
      .then((res) => {
        this.order = res.data.order
        this.orderitems = res.data.order_items
        axios
          .get(`/api/companies/${this.order.company_id}/contacts`)
          .then(response => {
            this.contacts = response.data
          })
        axios
          .get(`/api/companies/${this.order.company_id}/addresses`)
          .then(response => {
            this.addresses = response.data
          })
      })
  },
  methods: {
    onFocus: function () {
      this.isVisible = true
      this.searchProduct()
    },
    onBlur: function () {
      // this.isVisible = false
    },
    refreshOrder () {
      axios
        .get(`/api/orders/${this.$route.params.id}`)
        .then((res) => {
          this.order = res.data
        })
      axios
        .get(`/api/orders/${this.$route.params.id}/orderitems`)
        .then((res) => {
          this.orderitems = res.data
        })
    },
    updateOrder () {
      axios
        .put(`/api/orders/${this.$route.params.id}`, this.order)
        .then(response => (
          this.$router.push({ name: 'Orders' })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    addNewItem () {
      this.orderitems.push({})
    },
    finaliseOrder () {
      axios
        .get(`/api/orders/${this.$route.params.id}/actions/finalise`, this.order)
        .then(response => (
          this.refreshOrder()
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    invoiceOrder () {
      axios
        .get(`/api/orders/${this.$route.params.id}/actions/invoice`, this.order)
        .then(response => (
          this.refreshOrder()
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    payOrder () {
      axios
        .post(`/api/orders/${this.$route.params.id}/actions/pay`, this.order)
        .then(response => (
          this.refreshOrder()
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    fulfillOrder () {
      axios
        .post(`/api/orders/${this.$route.params.id}/actions/fulfill`, this.order)
        .then(response => (
          this.refreshOrder()
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    deleteOrder () {
      axios
        .get(`/api/orders/${this.$route.params.id}/actions/delete`, this.order)
        .then(response => (
          this.$router.push({ name: 'Orders' })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    },
    getContact (id) {
    }
  }
}
</script>
